import 'reflect-metadata'
import {inject, injectable} from 'inversify'
import {computed, makeObservable, observable, reaction, runInAction, toJS} from 'mobx'
import {message} from 'antd'
import {v4 as uuidv4} from 'uuid'
import {fetchDccSummary} from '../services'
import {ColumnsType} from 'antd/es/table'
import {
    DccTableFilterStoreSymbol,
    IDccTableFilterStore
} from '~/code/pages/DCC/components/DccTableFilter'
import {getColumns} from '../services/utills'
import {DccDataType, DccSummaryTotalsType} from '../models'
import {IDccStore} from '~/code/pages/DCC'

@injectable()
export class DccStore implements IDccStore {
    data: DccDataType[] = []
    isLoading: boolean = false
    totals: DccSummaryTotalsType | null = null
    dccTableFilterStore: IDccTableFilterStore

    constructor(
        @inject(DccTableFilterStoreSymbol)
        dccTableFilterStore: IDccTableFilterStore
    ) {
        this.dccTableFilterStore = dccTableFilterStore

        makeObservable(this, {
            data: observable,
            columns: computed,
            isLoading: observable,
            totals: observable
        })

        this.loadDccSummary()

        reaction(
            () => ({
                filter: dccTableFilterStore.filter
            }),
            () => this.loadDccSummary()
        )
    }

    get columns(): ColumnsType<DccDataType> {
        return getColumns()
    }

    public reload = (): Promise<void> => {
        return this.loadDccSummary()
    }

    loadDccSummary = async () => {
        runInAction(() => (this.isLoading = true))

        const {startDate, endDate, ...filter} = (this.dccTableFilterStore.filter ?? {}) as any

        const request = {
            from: startDate ? startDate.format('YYYY-MM-DD') : undefined,
            to: endDate ? endDate.format('YYYY-MM-DD') : undefined,
            ...filter
        }

        try {
            const {result, error} = await fetchDccSummary(request)

            if (error) throw new Error(error.message || 'Failed to fetch DCC summary data')

            const {data, ...rest} = result

            runInAction(() => {
                this.data = data.map((item) => ({
                    ...item,
                    id: uuidv4()
                }))
                this.totals = rest
            })
        } catch (error) {
            message.error(error.message)
        } finally {
            runInAction(() => (this.isLoading = false))
        }
    }
}
